import { rootUrl } from 'src/constants';
import { httpService } from 'src/services';

export function getEntityOptions(type: string, id: string) {
  return httpService.get(`${rootUrl}/entity-options/get-data?entity=${type}&id=${id}`);
}
